import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontFamilies, fontSizes, fontWeights, lineHeights, palette,
}: Theme) => ({
  root: {
    padding: '1.5rem',
    textAlign: 'center',
    [breakpoints.up('md')]: {
      padding: '3rem',
    },
  },
  lensesImage: {
    marginBottom: 12,
    [breakpoints.up('md')]: {
      marginBottom: 24,
    },
  },
  title: {
    margin: '0 0 0.75rem',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
    },
  },
  description: {
    margin: '0 0 16px',
    color: palette.text.primary,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.xs,
    [breakpoints.up('md')]: {
      margin: '0 0 24px',
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.lg,
    },
  },
  videoTitle: {
    margin: 0,
    color: palette.text.primary,
    fontSize: fontSizes.xs,
    lineHeight: 1.5,
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
    },
  },
  video: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: 'inherit',
    marginTop: '0.5rem',
    marginBottom: '2rem',
    paddingTop: '56.25%',
    overflow: 'hidden',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      border: 0,
      objectFit:' cover',
    },
  },
}));
